/**
 * Formats a number with Intl, but forces the `en-US` locale
 * @param {number} number 
 * @param {Intl.NumberFormatOptions=} options
 */
export default function (number, options) {
  return new Intl.NumberFormat('en-US', options).format(number);
}